import type { EditAssetWorkflowOptions } from '../../types';

export const editScheduleEntryWorkflow: EditAssetWorkflowOptions = {
  workflowKey: 'editSchedulEntryeWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'schedule',
  workflowIndex: 2,
  workflowName: 'Edit Schedule Entry',
  workflowActionIcon: 'EditOutlined',
  hideIfDisabled: true,
  workflowStateTransformFunction: (assetPayload: any, asset: any) => {
    // because of the way the form state was intially managed
    // I need this weird hack
    // I should be able to change this to something more sensible once I move over to the
    // setWorkflowFormatter pattern
    const fromDate = assetPayload.scheduleEntry[0];
    const updatedEntry = assetPayload.scheduleEntry[1][0];
    asset.entries = asset.entries.map((e: any) => {
      return e.from === fromDate
        ? {
            ...e,
            ...updatedEntry,
            from: updatedEntry.from,
            to: updatedEntry.to,
          }
        : e;
    });
    return asset;
  },
  assetSchemaMatcher: {
    type: 'object',
    properties: {
      archived: { type: 'boolean', const: false },
      active: { type: 'boolean', const: true },
    },
  },
  workflowStepOptions: [
    {
      workflowStepKey: 'updateScheduleEntry',
      workflowStepNavigationName: 'Update Schedule',
      workflowComponent: {
        workflowComponentType: 'scheduleEditEntry',
        prompt: 'What schedule entry do you want to edit',
        description: 'Select the date of the schedule entry you want to edit',
        help: '',
      },
      calculatedComponentProps: {
        scheduleId: {
          property: 'scheduleId',
          type: 'asset',
        },
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'scheduleEntry',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Edit Schedule Entry Summary',
        description: 'The schedule will be update.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
